module.exports = __webpack_public_path__ + "img/retroboy.e4d099af.jpg";